// extracted by mini-css-extract-plugin
export default {"point":"point_point__IdDnk","point-o":"point_point-o__xYNbq","point-m":"point_point-m__CrZrM","point-i":"point_point-i__LMYdW","name":"point_name__fzFtT"};